/* Kailar Neubau D · Produktseite (Quelle: showcase produktseite-d).
   Variante wählen (Preis, ct, Bild, ausverkauft), Menge, Galerie, Kaufleiste, Versandbalken, Größen-Kreise.
   In die Tüte macht d-kd.js über [data-kd-add]. Nur wenn eine App Zusatzfelder (properties[…]) gefüllt hat,
   legt diese Datei selbst über KD.cartAdd ein und sendet dieselben Ereignisse. Nichts bewegt sich: kein smooth scroll. */
(() => {
  const $ = (s, el = document) => el.querySelector(s);
  const $$ = (s, el = document) => [...el.querySelectorAll(s)];
  const emit = (el, name, detail) => el.dispatchEvent(new CustomEvent(name, { bubbles: true, detail }));
  const money = (c) => (c / 100).toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
  /* wie snippets/d-ct.liquid: Zehntel-Cent, halb aufgerundet */
  const ct = (c, n) => { const t = Math.floor((c * 10 + Math.floor(n / 2)) / n); return `${Math.floor(t / 10)},${t % 10} ct`; };
  const sized = (u, w) => (/[?&]width=\d+/.test(u) ? u.replace(/([?&]width=)\d+/, `$1${w}`) : u + (u.includes('?') ? '&' : '?') + `width=${w}`);
  const roots = [];

  function init(root) {
    if (root.dpReady) return; root.dpReady = true;
    const sec = root.closest('.shopify-section') || root.parentElement;
    let D; try { D = JSON.parse($('[data-dp-data]', sec).textContent); } catch (e) { return; }
    const T = D.t || {};
    const bar = $('[data-dp-bar]', root) || $('[data-dp-bar]');
    const scopes = bar && !root.contains(bar) ? [root, bar] : [root];
    const all = (s) => scopes.flatMap((el) => $$(s, el)).filter((el, i, a) => a.indexOf(el) === i);
    const buys = all('[data-dp-buy]');
    const idInput = $('[data-dp-id]', root);
    const form = idInput && idInput.form;
    const qtyBox = $('[data-dp-qty]', root);
    const qtyInput = $('[data-dp-qtyinput]', root);
    let packs = {}; try { packs = JSON.parse($('[data-dp-packs-data]', root)?.textContent || '{}'); } catch (e) { packs = {}; }

    let cur = D.variants.find((v) => String(v.id) === String(idInput?.value)) || D.variants[0];
    const sel = cur ? cur.options.slice() : [];
    const find = (opts) => D.variants.find((v) => v.options.every((o, i) => o === opts[i]));

    /* ---------- Variante ---------- */
    function setBuy(v) {
      const ok = !!(v && v.available);
      const label = !v ? T.unavailable : ok ? T.add : T.soldOut;
      buys.forEach((b) => {
        b.disabled = !ok;
        if (ok) b.dataset.kdAdd = v.id; else delete b.dataset.kdAdd;
        const l = $('[data-dp-label]', b); if (l && label) l.textContent = label;
      });
    }
    function setImage(v) {
      let slide = $('[data-dp-main]', root); if (!slide) return;
      /* Set: Set-Bild der Variante tauschen (d-bundle), das Variantenfoto kommt ins zweite Bild */
      if (slide.hasAttribute('data-dp-combo')) {
        const tpl = $(`template[data-dp-combo-v="${v.id}"]`, root);
        if (tpl) slide.replaceChildren(tpl.content.cloneNode(true));
        /* kd-web-Bilder (fertige Website-Bilder): kein Set-Foto, der Zoom zeigt das Bild der Variante */
        if (slide.hasAttribute('data-dp-zoom-img') && /kd-web-/.test(v.img || '')) slide.dataset.dpZoomImg = sized(v.img, 2000);
        slide = $('[data-dp-photo]', root);
      }
      if (!slide || !v.img) return;
      let img = $('img', slide);
      if (!img) { slide.replaceChildren(); img = document.createElement('img'); img.width = 1200; img.height = 1200; slide.append(img); }
      img.srcset = [600, 900, 1200].map((w) => `${sized(v.img, w)} ${w}w`).join(', ');
      img.sizes = '(min-width: 900px) 640px, 100vw';
      img.src = v.img; img.alt = v.alt || '';
      img.removeAttribute('width'); img.removeAttribute('height');
      const track = $('[data-dp-track]', root); if (track) track.scrollLeft = 0;
    }
    /* Packungs-Kacheln: Link auf dieselbe Farbe; Glas-Kacheln (data-dp-pack-o/-n) auf die Variante ihrer Stückzahl,
       Farbe gleich oder enthalten („Weiß“ → „Schwarz & Weiß gemischt“), sonst die erste lieferbare. */
    function setPacks() {
      const c = D.colorIndex > -1 ? sel[D.colorIndex] : '';
      $$('[data-dp-pack]', root).forEach((a) => {
        const o = Number(a.dataset.dpPackO ?? -1);
        let list = packs[a.dataset.dpPack] || [];
        if (o > -1) list = list.filter((x) => x.options[o] === a.dataset.dpPackN);
        if (!list.length) return;
        const pick = (f) => list.find((x) => x.available && f(x)) || list.find(f);
        const lc = c.toLowerCase();
        let m = c ? pick((x) => x.options.includes(c)) || pick((x) => x.options.some((y) => { y = y.toLowerCase(); return y.includes(lc) || lc.includes(y); })) : null;
        if (!m && o > -1) m = pick(() => true);
        const base = a.getAttribute('href').split('?')[0];
        a.setAttribute('href', m ? `${base}?variant=${m.id}` : base);
      });
    }
    function setOut() {
      sel.forEach((_, i) => {
        all(`[data-dp-opt="${i}"] [role="radio"]`).forEach((b) => {
          const o = sel.slice(); o[i] = b.dataset.value;
          const v = find(o); b.classList.toggle('is-out', !v || !v.available);
        });
      });
    }
    function render(push) {
      sel.forEach((val, i) => {
        all(`[data-dp-opt="${i}"] [role="radio"]`).forEach((b) => b.setAttribute('aria-checked', String(b.dataset.value === val)));
        const lab = $(`[data-dp-value="${i}"]`, root); if (lab) lab.textContent = val;
      });
      const v = find(sel);
      setBuy(v); setOut(); setPacks();
      if (!v) return;
      cur = v;
      if (idInput) idInput.value = v.id;
      const p = $('[data-dp-price]', root); if (p) p.textContent = money(v.price);
      const cp = $('[data-dp-compare]', root);
      if (cp) { const on = v.compare > v.price; cp.hidden = !on; cp.textContent = on ? money(v.compare) : ''; }
      const cl = $('[data-dp-ctline]', root); if (cl && D.n > 0 && T.perFilter) cl.innerHTML = T.perFilter.replace('__CT__', ct(v.price, D.n));
      const bp = bar && $('[data-dp-barprice]', bar); if (bp) bp.textContent = money(v.price);
      const bs = bar && $('[data-dp-barsub]', bar);
      if (bs) bs.textContent = D.colorIndex > -1 ? `${D.barBase} · ${v.options[D.colorIndex]}` : D.barBase;
      setImage(v); qtyRules(v);
      if (push && history.replaceState) {
        const u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(history.state, '', u);
      }
    }
    scopes.forEach((el) => el.addEventListener('click', (e) => {
      const b = e.target.closest('[data-dp-opt] [role="radio"]'); if (!b || !el.contains(b)) return;
      const i = Number(b.closest('[data-dp-opt]').dataset.dpOpt);
      if (sel[i] === b.dataset.value) return;
      sel[i] = b.dataset.value; render(true);
    }));
    /* Pfeiltasten in den Wahlgruppen wie bei Radios */
    scopes.forEach((el) => el.addEventListener('keydown', (e) => {
      const b = e.target.closest('[data-dp-opt] [role="radio"]'); if (!b) return;
      const d = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1 }[e.key]; if (!d) return;
      const list = $$('[role="radio"]', b.closest('[data-dp-opt]'));
      const nx = list[(list.indexOf(b) + d + list.length) % list.length];
      e.preventDefault(); nx.focus(); nx.click();
    }));

    /* ---------- Menge ---------- */
    let q = Number(qtyInput?.value) || 1;
    let rule = { min: 1, step: 1, max: 99 };
    function qtySet(n) {
      const { min, step, max } = rule;
      n = Math.max(min, Math.min(max, n));
      n = min + Math.round((n - min) / step) * step; if (n > max) n -= step;
      q = n;
      if (qtyInput) qtyInput.value = n;
      if (qtyBox) {
        $('output', qtyBox).textContent = n;
        $('[data-dp-less]', qtyBox).disabled = n - step < min;
        $('[data-dp-more]', qtyBox).disabled = n + step > max;
      }
      buys.forEach((b) => { b.dataset.kdQty = n; });
    }
    function qtyRules(v) {
      rule = { min: v.min || 1, step: v.step || 1, max: v.max || 99 };
      qtySet(q);
    }
    if (qtyBox) {
      $('[data-dp-less]', qtyBox).addEventListener('click', () => qtySet(q - rule.step));
      $('[data-dp-more]', qtyBox).addEventListener('click', () => qtySet(q + rule.step));
    }

    /* ---------- Zusatzfelder von Apps (z. B. Textify): selbst einlegen ---------- */
    const props = () => {
      if (!form) return null;
      const out = {}; let any = false;
      for (const [k, val] of new FormData(form).entries()) {
        const m = /^properties\[(.+)\]$/.exec(k);
        if (m && typeof val === 'string' && val.trim() !== '') { out[m[1]] = val; any = true; }
      }
      return any ? out : null;
    };
    const flash = (b, cls) => { b.classList.add(cls); clearTimeout(b.kdT); b.kdT = setTimeout(() => b.classList.remove(cls), cls === 'is-err' ? 3200 : 2200); };
    async function addWith(b, p) {
      if (b.classList.contains('is-busy') || !window.KD) return;
      b.classList.remove('is-done', 'is-err'); b.classList.add('is-busy'); b.setAttribute('aria-busy', 'true');
      try {
        if (b.dataset.kdCode && window.KD.codeApply) await window.KD.codeApply(b.dataset.kdCode).catch(() => {});
        const res = await window.KD.cartAdd(cur.id, q, p);
        flash(b, 'is-done'); emit(document, 'kd:cart-added', { ...res, button: b });
      } catch (e) {
        const m = $('.kd-btn__err span', b); if (m && e.message) m.textContent = e.message;
        flash(b, 'is-err'); emit(document, 'kd:cart-error', { message: e.message, button: b });
      } finally { b.classList.remove('is-busy'); b.removeAttribute('aria-busy'); }
    }
    root.dpBuy = (e, b) => {
      const p = props(); if (!p) return false;
      e.preventDefault(); e.stopPropagation(); addWith(b, p); return true;
    };
    root.dpBuys = buys;
    if (form) form.addEventListener('submit', (e) => { e.preventDefault(); const b = buys[0]; if (b && !b.disabled) b.click(); });

    /* ---------- Galerie ---------- */
    const gal = $('[data-dp-gal]', root);
    const track = gal && $('[data-dp-track]', gal);
    if (track) {
      const slides = () => [...track.children];
      const dots = $('[data-dp-dots]', gal);
      const idx = () => Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
      const go = (i) => { const s = slides(); i = (i + s.length) % s.length; track.scrollLeft = s[i].offsetLeft - s[0].offsetLeft; };
      const mark = () => { const i = idx(); $$('button', dots).forEach((d, k) => d.setAttribute('aria-current', String(k === i))); };
      const n = slides().length;
      gal.classList.toggle('is-single', n < 2);
      if (dots && n > 1) {
        dots.replaceChildren(...slides().map((_, i) => {
          const d = document.createElement('button'); d.type = 'button'; d.setAttribute('aria-label', `${i + 1} / ${n}`);
          d.addEventListener('click', () => go(i)); return d;
        }));
        mark();
      }
      let raf = 0;
      track.addEventListener('scroll', () => { if (!raf) raf = requestAnimationFrame(() => { raf = 0; mark(); }); }, { passive: true });
      $('[data-dp-prev]', gal)?.addEventListener('click', () => go(idx() - 1));
      $('[data-dp-next]', gal)?.addEventListener('click', () => go(idx() + 1));
      $('[data-dp-zoom]', gal)?.addEventListener('click', () => {
        /* Set-Bild (d-bundle) zoomt auf das Set-Foto, das dann nur einmal in der Liste steht */
        const per = slides().map((s) => (s.hasAttribute('data-dp-combo') ? $('[data-dp-photo] img', root) || (s.dataset.dpZoomImg ? { src: s.dataset.dpZoomImg } : null) : $('img', s))).map((im) => (!im ? '' : /cdn\/shop\/(files|products)\//.test(im.src) ? sized(im.src, 2000) : im.src));
        const urls = per.filter((u, i) => u && per.indexOf(u) === i);
        if (urls.length && window.KD) window.KD.lightbox(urls, Math.max(0, urls.indexOf(per[idx()])));
      });
    }

    /* ---------- Kaufbereich läuft auf dem Computer neben Bild und Beschreibung mit (d-product.css) ----------
       Passt er nicht in den Bildschirm, scrollt er beim Runterscrollen mit, bis sein Ende sichtbar ist, und klebt dann unten;
       beim Hochscrollen umgekehrt bis zum Kopf. So bleibt nichts unerreichbar. Passt er, klebt er per CSS unter dem Kopf. */
    const wide = matchMedia('(min-width: 900px)');
    const khOffset = () => parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--kh-offset')) || 0;
    const buyBox = $('.p-main > .p-buy', root);
    if (buyBox) {
      let top = null, max = 0, lastY = scrollY, raf = 0;
      const place = () => {
        raf = 0;
        const y = scrollY, d = y - lastY; lastY = y;
        const hi = khOffset() + 24, lo = innerHeight - buyBox.offsetHeight - 24;
        if (!wide.matches || lo >= hi) { if (top !== null) { buyBox.style.top = ''; top = null; } return; }
        /* klebte er oben, bleibt er oben, auch wenn der Kopf ein- oder ausfährt */
        if (top === null) top = hi; else top = (top >= max - 0.5 ? hi : top) - d;
        max = hi;
        top = Math.min(hi, Math.max(lo, top));
        buyBox.style.top = top + 'px';
      };
      const ask = () => { if (!raf) raf = requestAnimationFrame(place); };
      addEventListener('scroll', ask, { passive: true }); addEventListener('resize', ask);
      if (window.ResizeObserver) new ResizeObserver(ask).observe(buyBox);
      place();
    }

    /* ---------- Kaufleiste: an, sobald der Kaufknopf aus dem Bild ist ----------
       Computer: solange der Kaufbereich rechts mitläuft, ist sie doppelt; sie kommt erst darunter (Empfehlungen, Sortiment)
       und geht wieder, bevor sie den Fuß der Seite überdeckt. */
    const anchor = $('[data-dp-anchor]', root);
    if (bar && anchor) {
      let raf = 0;
      const foot = document.querySelector('footer');
      const check = () => {
        raf = 0;
        const r = anchor.getBoundingClientRect();
        let on = r.bottom < 0;
        if (wide.matches) {
          on = r.bottom < khOffset();
          if (on && foot) on = foot.getBoundingClientRect().top > innerHeight;
        }
        bar.classList.toggle('is-on', on);
      };
      const ask = () => { if (!raf) raf = requestAnimationFrame(check); };
      addEventListener('scroll', ask, { passive: true }); addEventListener('resize', ask); check();
    }

    /* ---------- Versandbalken ---------- */
    const ship = $('[data-dp-ship]', root);
    root.dpShip = (total) => {
      if (!ship || !D.freeFrom) return;
      const rest = D.freeFrom - total;
      ship.classList.toggle('is-free', rest <= 0);
      const txt = $('[data-dp-shiptext] > span:first-child', ship);
      if (txt) txt.innerHTML = rest <= 0 ? T.shipFree : T.shipRest.replace('__AMOUNT__', money(rest));
      const fill = $('[data-dp-shipfill]', ship);
      if (fill) fill.style.width = (rest <= 0 ? 100 : Math.floor(total * 100 / D.freeFrom)) + '%';
    };

    if (cur) { qtyRules(cur); setOut(); setPacks(); }
    roots.push(root);
  }

  /* vor d-kd.js (das auf document in der Bubble-Phase hört) */
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-dp-buy]'); if (!b || b.disabled) return;
    const r = roots.find((x) => x.dpBuys && x.dpBuys.includes(b));
    if (r) r.dpBuy(e, b);
  }, true);
  document.addEventListener('kd:cart-updated', (e) => {
    const c = e.detail && e.detail.cart; if (!c) return;
    roots.forEach((r) => r.dpShip && r.dpShip(c.total_price));
  });

  /* GPSR-App schreibt die Hersteller-Webseite ohne https:// („kailar.de“) – der Link lief relativ auf eine 404 (07.10.) */
  const fixGpsr = () => $$('.gpsr-section-content a[href]').forEach((a) => {
    const h = (a.getAttribute('href') || '').trim();
    if (h && !/^(https?:|mailto:|tel:|\/|#)/i.test(h)) a.setAttribute('href', 'https://' + h);
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fixGpsr); else fixGpsr();

  const start = (scope = document) => $$('[data-dp]', scope).forEach(init);
  document.addEventListener('shopify:section:load', (e) => start(e.target));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => start()); else start();
})();
